import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OnceNgIfDirective } from './once-ng-if.directive';


@NgModule({
    declarations: [OnceNgIfDirective],
    imports: [
        CommonModule
    ],
    exports: [
        OnceNgIfDirective
    ]
})
export class OnceNgIfModule {}
